exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/object-get-own-property-symbols.js
// module id = 279
// module chunks = 0